import TranslationsConfigType from './translationType';

const nbTranslations: TranslationsConfigType = {
    confirmationScreen: {
        consumerLoanTitle: 'Forbrukslån',
        refinancingTitle: 'Refinansiering',
        title: 'Beregn pris og søk',
        description:
            '{} leveres av Kredittbanken. For at Kredittbanken enkelt skal behandle søknaden din deler vi opplysinger om deg mens du søker.',
        toggleButtonText: 'Hvilke opplysninger deles?',
        listTitle: 'Du deler:',
        phone: 'telefonnummer',
        email: 'e-post',
        customerRelationship: 'bekreftelse på at du er bankkunde hos oss',
        loanLinkText: 'Beregn pris og søk',
    },
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        defaultMessage: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv igjen litt senere.',
        errorCodeHeader: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
        informationModalTitle: 'Hva kan jeg bruke feilkoden til?',
        informationModalDescription:
            'Når det oppstår en feil, hender det man blir nødt til å kontakte banken for å få hjelp. Da er det veldig nyttig å ha en feilkode banken kan få, så vi lettere kan se hva som er gått galt. \n' +
            '\n' +
            'Ta et skjermbilde av feilmeldingen eller les opp feilkoden til personen du prater med på telefon. Skriver du med oss via meldinger i mobil- eller nettbank? Da kan du enkelt klikke «Kopier feilkode», for deretter å lime den inn i meldingsvinduet til den bankansatte du skriver med.\n' +
            '\n' +
            'Sammen finner vi ut av hva som har gått galt. Lykke til!',
    },
    goBack: 'Gå tilbake',
    nominalInterest: 'Nominell rente {}%',
    loanListTitle: 'Andre lån',
    loanOwners: {
        title: 'Låntakere',
        accountRole: {
            DEBTOR: 'Eier av lån',
            CO_DEBTOR: 'Medlåntaker',
            GUARANTOR: 'Kausjonist',
            UNKNOWN: 'Ukjent',
        },
    },
    loanDetails: {
        title: 'Detaljer',
        name: 'Navn på lån',
        intialAmount: 'Opprinnelig lånebeløp',
        maturityDate: 'Nedbetalingsdato',
        effectiveInterest: 'Effektiv rente',
        paymentDate: 'Forfallsdato',
        paymentDay: '{}. hver måned',
        instalmentAmount: 'Terminbeløp',
    },
    loanInterest: {
        nominalInterest: 'Nominell rente',
        effectiveInterest: 'Effektiv rente {}%',
        loanRepaymentLinkTitle: 'Se nedbetalingsplan',
        loanRepaymentLinkDescription: 'Hos Kredittbanken',
    },
    loanOverview: {
        accountName: 'Kontonavn',
        accountNumber: 'Kontonummer',
        disposible: 'Disponibelt',
        moneyOnTheWay: 'Pengene er på vei. Det kan ta noen virkedager før pengene er utbetalt.',
        interest: 'Nominell rente',
        paymentDueDate: 'Neste innbetaling',
        instalmentAmount: 'Beløp',
        extraPayment: 'Ekstra innbetaling',
        more: 'Mer',
        changeDate: 'Endre forfall',
        seeDocuments: 'Se faktura og dokumenter',
        atKredittbanken: 'Hos Kredittbanken',
        infoKredittbankne: 'Våre forbrukslån og kredittkort leveres av Kredittbanken',
        showLoanAtKredittbanken: 'Se lånet ditt hos Kredittbanken',
        loanPayedDown: 'Lånet er nedbetalt',
    },
    transactions: {
        noTransactions: 'Her har det ikke skjedd så mye!',
        noMoreTransactionsToLoad: 'Det var alle transaksjonene på denne kontoen',
        reserved: 'Reservert',
        couldNotLoadMoreTransactions:
            'Vi beklager, det har skjedd en teknisk feil så vi klarte ikke å laste flere transaksjoner. Prøv igjen litt senere.',
        tryAgain: 'Prøv igjen',
    },
};

export default nbTranslations;
